import {RulebookPage} from '../../../../shared/enums/RulebookEnums'
import {UIPopupRulebook} from '../ui_popup/UIPopupRulebook'

let rulebookPopupGlobal: UIPopupRulebook | undefined

export function showRulebookPopup(page: RulebookPage = RulebookPage.Classic4P) {
    if(rulebookPopupGlobal == undefined) rulebookPopupGlobal = new UIPopupRulebook(page)
    rulebookPopupGlobal.setDefaultPage(page)
    rulebookPopupGlobal.show()
}
